import Uppy from "@uppy/core";
import AwsS3Multipart from "@uppy/aws-s3-multipart";
import {PluginUpload} from "./PluginUpload";

const apiURL = process.env.REACT_APP_BACKEND_API_URL;

export const uppyInstanceImage = ({
    id = "",
    video_id = "",
    uploadType = "",
    autoProceed = false,
    token = "",
    maxFileSize = 209715200,
    maxNumberOfFiles = 4,
    height = 470,
    onSuccess = () => {},
    onFail = () => {},
}) => {
    const uppy = new Uppy({
        id,
        meta: {uploadType, video_id},
        debug: true,
        restrictions: {
            maxFileSize,
            maxNumberOfFiles,
            minNumberOfFiles: 1,
            allowedFileTypes: ["image/*"],
        },
        trigger: ".UppyModalOpenerBtn",
        inline: true,
        target: ".DashboardContainer",
        replaceTargetContent: true,
        showProgressDetails: true,
        note: "Images files only",
        height,
        autoProceed,
        browserBackButtonClose: false,
        onBeforeFileAdded: (currentFile, files) => {
            if (currentFile && currentFile.type.includes("image")) {
                if (currentFile.data.size > maxFileSize) {
                    //set our limit here
                    uppy.info(`Image "${currentFile.name}" is too big`, "error", 4000);
                    return false;
                }
                if (!currentFile.name) {
                    uppy.info(`Image should have a name`, "error", 4000);
                    return false;
                }

                if (Object.keys(files).length === maxNumberOfFiles) {
                    uppy.info(`Maximum ${maxNumberOfFiles} images are allowed`, "error", 4000);
                    return false;
                }
                return currentFile;
            }
        },
    });

    //set s3 multipart:
    uppy.use(AwsS3Multipart, {
        companionUrl: `${apiURL}`,
        companionHeaders: {
            "Access-Control-Allow-Origin": "*",
            "uppy-auth-token": token,
        },
        abortMultipartUpload: () => {},
    });

    uppy.use(PluginUpload, {
        companionUrl: `${apiURL}`,
        companionHeaders: {
            "uppy-auth-token": token,
        },
    });

    //events:
    uppy.on("upload-success", (file, response) => {
        uppy.info(`Successfully uploaded file: ${file.name}`, "info", 4000);
        onSuccess();
    });

    uppy.on("upload-error", (file, error) => {
        uppy.info(`Error on uploading file '${file.name}':", ${error}`, "error", 4000);
        onFail();
    });

    uppy.on("error", error => {
        uppy.info(error.stack, "error", 4000);
    });

    uppy.on("file-removed", file => {
        uppy.info(`Removed file ${file}`, "info", 4000);
    });

    uppy.on("cancel-all", () => {
        uppy.info("Cancel all", "info", 4000);
    });

    return uppy;
};
